import React, { useEffect, useState } from "react";
import { Box, List, ListItemButton, ListItemText } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentClientSubDivisionListRequest,
  getCurrentClientSubDivisionListSuccess,
  getCurrentSubdivisionDetailsRequest,
  getCurrentSubdivisionDetailsSuccess,
} from "../../../../../redux/clients/slice";
import Loading from "../../../../../components/loading/loading";
import "./client-divisions.css";
import DivisionDetails from "./division-details";

export default function ClientDivisions() {
  const [subDivisions, setSubDivisions] = useState<any[]>([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const dispatch = useDispatch();

  const { currentSubDivisionList, loading, currentSubDivisionDetails } =
    useSelector((state: any) => state?.clients);

  useEffect(() => {
    dispatch(getCurrentSubdivisionDetailsSuccess({ response: null }));
    dispatch(getCurrentClientSubDivisionListSuccess({ response: null }));
    dispatch(getCurrentClientSubDivisionListRequest());
  }, [dispatch]);

  useEffect(() => {
    if (currentSubDivisionList) {
      setSubDivisions(currentSubDivisionList);
    }
  }, [currentSubDivisionList]);

  useEffect(() => {
    if (subDivisions && subDivisions?.length > 0) {
      setSelectedIndex(0);
      dispatch(
        getCurrentSubdivisionDetailsRequest({
          subDivisionId: subDivisions[0]?.id,
        })
      );
    }
  }, [subDivisions]); // eslint-disable-line

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
    item: any
  ) => {
    setSelectedIndex(index);
    dispatch(getCurrentSubdivisionDetailsRequest({ subDivisionId: item?.id }));
  };

  return (
    <Box className="client-division-container">
      <Box className="client-division-list-layout">
        <List component="nav" aria-label="sub division" sx={{ width: 250 }}>
          {subDivisions?.map((item: any, index: number) => (
            <ListItemButton
              key={item.id}
              selected={selectedIndex === index}
              onClick={(event) => handleListItemClick(event, index, item)}
            >
              <ListItemText primary={item.displayName} />
            </ListItemButton>
          ))}
        </List>
      </Box>
      {currentSubDivisionDetails && (
        <Box className="client-division-details-layout">
          <DivisionDetails data={currentSubDivisionDetails} />
        </Box>
      )}
      {loading && <Loading />}
    </Box>
  );
}
